import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-index-courier',
  templateUrl: './index-courier.component.html',
  styleUrls: ['./index-courier.component.css']
})

/***
 * Task Management Component
 */
export class IndexCourierComponent implements OnInit {

  /***
   * nav bg color add
   */
  navClass = 'nav-light';
    // Set Topbar Option
    Menuoption = 'center';
    Settingicon = false;
  /**
   * Services Data
   */
  servicesData = [
    {
      icon: "uil uil-airplay h1 text-primary",
      title: "Easy To Use",
      description: "Nisi aenean vulputate eleifend tellus vitae eleifend enim a eleifend Aliquamaenean elementum semper."
    },
    {
      icon: "uil uil-envelope-shield h1 text-primary",
      title: "Secure",
      description: "Allegedly, a Latin scholar established the origin of the established text by compiling unusual word."
    },
    {
      icon: "uil uil-edit-alt h1 text-primary",
      title: "Flexible",
      description: "It seems that only fragments of the original text remain in only fragments the Lorem Ipsum texts used today."
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
